<div class="passwordPage">
    <form [formGroup]="passwordFormGroup" (ngSubmit)="resetPassword()">
        <div class="container">
            <div class="form">
                <div class="portalLogo mb-5" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
                <div class="text-center">
                    <h2>{{ 'resetPassword.title' | translate }}</h2>
                    <p [innerHTML]="'resetPassword.description' | translate"></p>
                </div>
                <div class="form-group">
                    <input class="form-input" name="newPassword" id="new-password"
                        formControlName="newPassword" type="password"
                        [placeholder]="'resetPassword.newPassword' | translate"
                        [(ngModel)]="newPassword" required minlength="6"/>
                    <label for="new-password" class="form_label">{{ 'resetPassword.newPassword' | translate }}</label>
                    <div class="alert alert-danger"
                        *ngIf="passwordFormGroup.hasError('required', 'newPassword') && !passwordFormGroup.get('newPassword')?.pristine">
                        <span>{{ 'resetPassword.passwordRequired' | translate }}</span>
                    </div>
                    <div class="alert alert-danger"
                        *ngIf="passwordFormGroup.hasError('minlength', 'newPassword')">
                        {{ 'resetPassword.passwordMinLength' | translate }}
                    </div>
                </div>
                <div class="form-group">
                    <input class="form-input" id="confirm-password" name="confirmPassword"
                        formControlName="confirmPassword" type="password"
                        [placeholder]="'resetPassword.confirmPassword' | translate"
                        [(ngModel)]="confirmPassword"/>
                    <label for="confirm-password" class="form_label">{{ 'resetPassword.confirmPassword' | translate }}</label>
                    <div *ngIf="passwordFormGroup.hasError('mismatch', 'confirmPassword')"
                        class="alert alert-danger">
                        {{ 'resetPassword.passwordMismatch' | translate }}
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6 offset-6">
                        <button type="submit"
                            class="primary-button"
                            [class.disabled]='!passwordFormGroup.valid || disableButtons'
                            [disabled]="!passwordFormGroup.valid || disableButtons">
                            {{ 'resetPassword.resetButton' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>